<template>
  <b-col sm="12" :lg="lgSize" :offset-lg="lgOffset">
    <div class="animated fadeIn">
      <b-modal
        title="Choose period"
        class="modal-primary"
        v-model="modalDate"
        @ok="fetchData(), (modalDate = false)"
      >
        <b-form>
          <b-form-group label="From" label-for="date" :label-cols="3">
            <datepicker use-utc
              format="MM/dd/yyyy"
              :bootstrap-styling="true"
              v-model="dateFrom"
              name="dateFrom"
            ></datepicker>
          </b-form-group>
          <b-form-group label="To" label-for="dateTo" :label-cols="3">
            <datepicker use-utc
              format="MM/dd/yyyy"
              :bootstrap-styling="true"
              v-model="dateTo"
              name="dateTo"
            ></datepicker>
          </b-form-group>
        </b-form>
      </b-modal>

      <b-card class="backClass" header="Received">
        <div slot="header">
          <h5 style="display: inline;" class="card-title mb-0">
            All depots | Received Equipment
            <small style="font-weight:600; color:#20a8d8">
              {{ from ? $formatUSDate(from) : $formatUSDate(dateFrom) }}
              <b>|</b>
              {{ to ? $formatUSDate(to) : $formatUSDate(dateTo) }}
            </small>
          </h5>
          <div class="card-header-actions">
            <b-button
              @click="toggleFullScreen"
              style="height: 26px; width: 26px"
              class="float-right"
              variant="transparent p-0"
              right
            >
              <i style="color: #20a8d8;" class="icon-frame"></i>
            </b-button>
            <b-button
              @click="modalDateEvent"
              class
              style="height: 26px; width: 26px"
              variant="transparent p-0"
            >
              <i class="icon-calendar" style="color: #20a8d8;"></i>
            </b-button>
            <b-button
              class="btn"
              style="height: 26px; width: 26px"
              variant="transparent p-0"
              attr="pdf"
              @click="downloadPDF()"
            >
              <i
                class="fa fa-file-pdf-o"
                style="color: rgb(32, 168, 216);"
                aria-hidden="true"
              ></i>
            </b-button>
          </div>
        </div>
        <div style="margin-top: 30px" class="chart-wrapper">
          <div
            style="height: 400px; padding-top: 150px"
            v-if="loadingData"
            class="loading"
          >
            <b-row>
              <b-col lg="12">
                <div class="sk-double-bounce">
                  <div class="sk-child sk-double-bounce1"></div>
                  <div class="sk-child sk-double-bounce2"></div>
                </div>
              </b-col>
            </b-row>
          </div>
          <highcharts
            ref="backRef"
            v-else
            :options="chartOptions"
            class="chart"
            :constructor-type="'chart'"
          ></highcharts>
        </div>
        <!--        <div slot="footer">-->
        <!--          <b-button-->
        <!--            :disabled="!showAll"-->
        <!--            class="btn-outline"-->
        <!--            variant="outline-primary"-->
        <!--            left-->
        <!--            @click="showAll = false, fetchData()"-->
        <!--          >Top 10</b-button>-->

        <!--          <b-button-->
        <!--            :disabled="showAll"-->
        <!--            class="btn-outline float-right"-->
        <!--            variant="outline-primary"-->
        <!--            right-->
        <!--            @click="showAll = true, fetchData()"-->
        <!--          >All Data</b-button>-->

        <!--          <b-button-->
        <!--            class="btn-outline text"-->
        <!--            v-if="isCelia"-->
        <!--            style="margin-right:10px; float:right"-->
        <!--            variant="outline-primary"-->
        <!--            @click=" () => $router.push('/base/TableAllDataC?type=backlog')"-->
        <!--          >Overall Data</b-button>-->

        <!--          <b-button-->
        <!--            class="btn-outline text"-->
        <!--            v-else-->
        <!--            style="margin-right:10px; float:right"-->
        <!--            variant="outline-primary"-->
        <!--            @click=" () => $router.push('/base/TableAllData?type=backlog')"-->
        <!--          >Overall Data</b-button>-->

        <!--        </div>-->
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../router";
import Highcharts from "highcharts";
import exporting from "highcharts/modules/exporting";
import Datepicker from "vuejs-datepicker";

exporting(Highcharts);
export default {
  name: "OfficeShipped",
  components: {
    router,
    highcharts: Chart,
    Highcharts,
    Datepicker
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity", "nameCity"],
  data: function() {
    return {
      fullscreen: false,
      city: "",
      modalDate: false,
      loadingData: false,
      isCelia: false,
      showAll: false,
      dateFrom: "",
      dateTo: "",
      shippedLocation: "",
      shippedProductGroup: "",
      locationsIds: "",
      chartOptions: {
        chart: {
          type: "pie",
          backgroundColor: "transparent",
          events: {
            drilldown: ({ point }) => {
              this.shippedLocation = point.name;
            },
            drillup: ({ e }) => {
              this.shippedLocation = "";
            }
          }
        },
        exporting: {
          enabled: true
        },
        title: {
          text: "",
          style: {
            color: "white",
            display: ""
          }
        },
        subtitle: {
          text: "Click the bars to view by product group",
          style: {
            color: "white",
            display: ""
          }
        },
        xAxis: {
          type: "category",
          labels: {
            style: {
              color: "white"
            }
          }
        },
        yAxis: {
          title: {
            text: "Percentage Of Total"
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            "<span >{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>"
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: "{point.name}: {point.y:.1f}%",
              color: "white",
              style: {
                textOutline: false
              }
            },
            point: {
              events: {
                click: ({ point }) => {
                  if (typeof this.dateFrom === "object") {
                    this.dateFrom = this.dateFrom.toISOString().split("T")[0];
                  }
                  if (typeof this.dateTo === "object") {
                    this.dateTo = this.dateTo.toISOString().split("T")[0];
                  }

                  if (point.name) {
                    this.shippedProductGroup = point.name;
                    if (this.locParam == 1) {
                      // router.push(
                      //     "/base/Tables/?location=" +
                      //     this.shippedLocation +
                      //     "&productGroup=" +
                      //     this.shippedProductGroup +
                      //     "&type=officeshipped&date_from=" +
                      //   this.dateFrom +
                      //   "&date_to=" +
                      //   this.dateTo +
                      //     "&clients=" +
                      //     this.locationsIds
                      // );
                    } else {
                      // router.push(
                      //     "/base/Tables/?location=" +
                      //     this.city +
                      //     "&productGroup=" +
                      //     this.shippedProductGroup +
                      //     "&type=officeshipped" +
                      //     "&clients=" +
                      //     this.locationsIds
                      // );
                    }
                  }
                }
              }
            }
          }
        },
        drilldown: {
          activeAxisLabelStyle: {
            textDecoration: "none",
            color: "white"
          },
          activeDataLabelStyle: {
            color: "white"
          }
        },
        series: [
          {
            name: "Company",
            colorByPoint: true,
            data: null
          }
        ]
      }
    };
  },
  computed: {
    from() {
      if (typeof this.dateFrom === "object") {
        this.dateFrom = this.dateFrom.toISOString().split("T")[0];
        return this.dateFrom;
      }
    },
    to() {
      if (typeof this.dateTo === "object") {
        this.dateTo = this.dateTo.toISOString().split("T")[0];
        return this.dateTo;
      }
    }
  },
  methods: {
    modalDateEvent() {
      if (this.fullScreen) {
        this.toggleFullScreen();
        this.modalDate = true;
      } else {
        this.modalDate = true;
      }
    },
    detailView() {
      this.$emit("detailView");
    },
    toggleFullScreen() {
      this.$fullscreen.toggle(this.$el.querySelector(".backClass"), {
        wrap: false,
        callback: this.fullscreenChange
      });
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        date_from: this.dateFrom,
        date_to: this.dateTo,
        chartType: "Received"
      };
      this.$http.get("api/fns/charts/allOffices.php", { params }).then(
        res => {
          console.log(res);
          if (!this.showAll) {
            let tmp = res.data.upData;
            tmp.sort((a, b) =>
              parseFloat(a.locationTotal) > parseFloat(b.locationTotal) ? -1 : 1
            );

            let smp = res.data.dnData;

            smp.forEach((value, index) => {
              value.data.sort((a, b) =>
                parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
              );
            });

            let newArr = tmp.slice(0, 10);

            if (this.locParam == 0) {
              if (smp.length != 0) {
                this.chartOptions.series[0].data = smp[0].data;
              }
            } else {
              this.chartOptions.series[0].data = newArr;
              this.chartOptions.drilldown.series = smp;
            }
          } else {
            let smp = res.data.dnData;

            smp.forEach((value, index) => {
              value.data.sort((a, b) =>
                parseInt(a[1]) > parseInt(b[1]) ? -1 : 1
              );
            });
            let tmp = res.data.upData;
            tmp.sort((a, b) =>
              parseFloat(a.locationTotal) > parseFloat(b.locationTotal) ? -1 : 1
            );
            if (this.locParam == 0) {
              this.chartOptions.series[0].data = smp[0].data;
            } else {
              this.chartOptions.series[0].data = tmp;
              this.chartOptions.drilldown.series = smp;
            }
          }
          //              // Getting total amount wihtout response
          // var seriesData = this.chartOptions.series;
          // var pointSum = 0;
          // seriesData.forEach(function(point) {
          //   var datasValue = point.data;
          //   datasValue.forEach(function(value) {
          //     pointSum += parseInt(value.locationTotal);
          //   })
          // });

          this.chartOptions.title.text = "Total units: " + res.data.totals;

          this.loadingData = false;
          setTimeout(() => {
            this.changeHeight();
          });
        },
        err => {
          this.loadingData = false;
          console.log(err);
        }
      );
    },
    changeHeight() {
      if (this.fullscreen) {
        this.$refs.backRef.chart.options.chart.height = "50%";
      } else {
        this.$refs.backRef.chart.options.chart.height = 400;
      }
      this.$refs.backRef.chart.reflow();
    },
    downloadPDF() {
      if (this.locParam == 1) {
        this.$refs.backRef.chart.options.title.text =
          "Active Backlog | " + this.dateTo + " " + this.shippedLocation;
        this.$refs.backRef.chart.options.title.style.color = "black";
      } else {
        this.$refs.backRef.chart.options.title.text =
          "Active Backlog | " + this.dateTo + " " + this.nameCity;
        this.$refs.backRef.chart.options.title.style.color = "black";
      }

      this.$refs.backRef.chart.options.title.style.display = "block";
      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "black";

      this.$refs.backRef.chart.options.xAxis.forEach(obj => {
        obj.labels.style.color = "black";
      });

      this.$refs.backRef.chart.exportChart({
        type: "application/pdf",
        filename: "ActiveBacklog-" + this.dateTo
      });

      this.$refs.backRef.chart.options.drilldown.activeAxisLabelStyle.color =
        "white";
    }
  },
  mounted() {
    if (!localStorage.getItem("fns_user")) {
      router.push("/pages/login/");
    }
    if (
      localStorage.getItem("full_name") === "Celia Mijares" ||
      localStorage.getItem("full_name") === "Rachel L. Francis"
    ) {
      this.isCelia = true;
    }
    this.dateTo = new Date().toJSON().slice(0, 10);
    if (this.locParam == 1) {
      this.locationsIds = localStorage.getItem("locations");
    } else {
      this.locationsIds = this.idCity;
      this.city = this.nameCity + "%287%29";
    }

    let fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 30);

    this.dateFrom = fromDate.toJSON().slice(0, 10);
    this.dateTo = new Date().toJSON().slice(0, 10);

    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-exporting-group {
  display: none !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>
